/**
 * Enum for reservation pricing component
 * @enum {string}
 * @readonly
 */
export const PricingComponent = Object.freeze({
  BASE_FARE: 'BASE_FARE',
  TAXES: 'TAXES',
  FEES: 'FEES',
});

/**
 * Map of pricing components to their human readable names
 * @type {Object.<string, string>}
 * @readonly
 */
export const PricingComponentCopy = Object.freeze({
  [PricingComponent.BASE_FARE]: 'Base fare',
  [PricingComponent.TAXES]: 'Taxes',
  [PricingComponent.FEES]: 'Fees',
});

/**
 * Enum for reservation rate code
 * @enum {string}
 * @readonly
 */
export const CommissionType = Object.freeze({
  PERCENTAGE: 'PERCENTAGE',
  FLAT: 'FLAT',
});

/**
 * Enum for reservation identifier kind
 * @enum {string}
 * @readonly
 */
export const IdentifierKind = Object.freeze({
  CONFIRMATION_NUMBER: 'CONFIRMATION_NUMBER',
  RECORD_LOCATOR: 'RECORD_LOCATOR',
  OTHER: 'OTHER',
});

/**
 * Map of identifier kinds to their human readable names
 * @type {Object.<string, string>}
 * @readonly
 */
export const identifierKinds = {
  [IdentifierKind.CONFIRMATION_NUMBER]: 'Confirmation number',
  [IdentifierKind.RECORD_LOCATOR]: 'Record locator',
  [IdentifierKind.OTHER]: 'Other',
};
